import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dropdown,
  Grid,
  Header,
  Modal,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';

import { flashErrorMessage, flashSuccessMessage } from '../../actions/flash';
import { promptChangesMessage } from '../../actions/prompt';
import PICTURE_TYPES from '../../constants/pictureTypes';
import PictureList from '../../components/PictureList';
import UploadModal from '../../components/UploadModal';
import LoadImage from '../../components/LoadImage';
import ViewLarge from './ViewLarge';

import {
  UPLOAD_PICTURE_PROMPT,
} from '../../constants/promptMessages';

import Form from '../Pictures/Form';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

class AddPicture extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func,
    onConfirm: PropTypes.func,
    onUpload: PropTypes.func,
    onCheck: PropTypes.func,
    type: PropTypes.oneOf(['project', 'unit_layout']).isRequired,
    t: PropTypes.func,
  }
  constructor(props) {
    super(props);
    this.state = {
      showLarge: false,
      showAdd: false,
      selectedPicture: null,
      referenceType: PICTURE_TYPES[0].value,
      uploadModalState: false,
    };
  }
  fixBody = () => {
    const anotherModal = document.getElementsByClassName('ui page modals');
    if (anotherModal.length > 0) {
      document.body.classList.add('dimmable', 'dimmed');
    }
  }
  handleRefetch = () => {
    if (this.pictureList) {
      this.pictureList.getWrappedInstance().handleRefetch();
    }
  }
  handleViewLarge = (e, selectedPicture) => {
    e.preventDefault();
    this.setState({ selectedPicture }, () => {
      this.setState({
        showLarge: true,
      });
    });
  }
  handleCloseLarge = (e) => {
    e.preventDefault();
    this.setState({
      showLarge: false,
      selectedPicture: null,
    });
  }
  handleAddPicture = (e) => {
    e.preventDefault();
    if (this.props.onConfirm) {
      this.props.onConfirm(e, this.state.selectedPicture, this.state.referenceType);
    }
    this.setState({
      selectedPicture: null,
      showAdd: false,
    }, () => {
      this.fixBody();
    });
  }
  handleOnClose = (e) => {
    if (this.props.onClose) {
      this.props.onClose(e);
    }
  }
  checkAdded(data) {
    if (this.props.onCheck) {
      return this.props.onCheck(data);
    }
    return false;
  }
  handleOnUpload = (e, data) => {
    if (this.props.onUpload) {
      e.preventDefault();
      const { url, options } = this.props.onUpload(data);
      if (url && options) {
        this.upload(url, options);
      }
    }
  }
  upload = async (url, options) => {
    const { t } = this.props;
    const { store } = this.context;
    try {
      await this.form.getWrappedInstance().submit(url, options);
    } catch (err) {
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        let message = await err.res.text();
        if (err.res.status === 413) {
          message = t('Uploaded document/image too large', { ns: TRANSLATION_FILES.translation });
        }
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
      return;
    }
    this.setState({ uploadModalState: false });
    this.handleRefetch();
    store.dispatch(flashSuccessMessage({ header: t('Upload Success', { ns: TRANSLATION_FILES.translation }), message: t('Picture(s) successfully uploaded', { ns: TRANSLATION_FILES.translation }) }));
  }
  handleTypeChange = (e, { value }) => {
    const referenceType = value;
    this.setState({ referenceType });
  }
  handleShowAdd = (e, selectedPicture) => {
    e.preventDefault();
    this.setState({
      showAdd: true,
      selectedPicture,
      referenceType: selectedPicture.type,
    });
  }
  handleCancelAdd = (e) => {
    if (e) { e.preventDefault(); }
    this.setState({
      showAdd: false,
      selectedPicture: null,
      referenceType: PICTURE_TYPES[0].value,
    }, () => {
      this.fixBody();
    });
  }
  handleCheckBeforeClose = () => {
    const { t } = this.props;
    if (this.form.getWrappedInstance().state.uploads.length > 0) {
      const callback = () => {
        this.form.getWrappedInstance().resetFiles();
        this.setState({ uploadModalState: false });
        this.handleRefetch();
      };
      const { store } = this.context;
      store.dispatch(promptChangesMessage({ message: t(UPLOAD_PICTURE_PROMPT, { ns: TRANSLATION_FILES.translation }), callback }));
      return true;
    }
    return false;
  }
  handleUploadModalStateChange = (open) => {
    this.setState({ uploadModalState: open });
  }
  render() {
    const { t } = this.props;
    return (
      <Modal
        className="add-picture"
        open={this.props.open === true}
        onClose={this.handleOnClose}
        closeIcon="close"
        size="large"
      >
        <Header icon="image outline" content={`${t('addPictures', { ns: TRANSLATION_FILES.screens })}`} />
        <Modal.Content scrolling>
          <Grid verticalAlign="middle" columns="equal">
            <Grid.Row>
              <Grid.Column>
                <ViewLarge
                  open={this.state.showLarge}
                  onClose={this.handleCloseLarge}
                  picture={this.state.selectedPicture}
                />
                <PictureList
                  ref={(ref) => { this.pictureList = ref; }}
                  toggleable
                  onViewLarge={this.handleViewLarge}
                  onRemove={this.handleRemove}
                  buttonNode={({ view, loading, picture }) => (
                    <Button
                      compact size="small"
                      attached={view === 'card' ? 'bottom' : null}
                      primary={!this.checkAdded(picture)}
                      positive={this.checkAdded(picture)}
                      icon={this.checkAdded(picture) ? 'checkmark' : 'add'}
                      content={t(this.checkAdded(picture) ? 'added' : 'add', { ns: TRANSLATION_FILES.screens })}
                      disabled={this.checkAdded(picture) || loading}
                      onClick={e => this.handleShowAdd(e, picture)}
                    />
                  )}
                  searchRightNav={
                    this.props.onUpload ? (
                      <UploadModal
                        modalState={this.state.uploadModalState}
                        floated="right"
                        header={t('pictures', { ns: TRANSLATION_FILES.translation })}
                        onModalStateChange={this.handleUploadModalStateChange}
                        onConfirm={this.handleOnUpload}
                        onClose={this.handleCheckBeforeClose}
                        content={({ onConfirm }) => (
                          <Form
                            ref={(ref) => { this.form = ref; }}
                            onSubmit={onConfirm}
                          />
                        )}
                      />
                    ) : null
                  }
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Modal.Content>
        <Modal.Actions>
          <Modal
            open={this.state.showAdd}
            onClose={this.handleCancelAdd}
            closeIcon="close"
            size="large"
          >
            <Header icon="add" content={` ${t('addPictureTo', { ns: TRANSLATION_FILES.screens })} ${this.props.type.replace('_', ' ')}`} />
            <Modal.Content scrolling>
              <Grid columns="equal" stackable doubling>
                <Grid.Column>
                  <LoadImage
                    wrapped
                    picture={this.state.selectedPicture}
                    pictureSize={70}
                  />
                </Grid.Column>
                <Grid.Column className="ui form">
                  <div className="field">
                    <label htmlFor="type">{t('Type', { ns: TRANSLATION_FILES.screens })}</label>
                    <Dropdown
                      options={PICTURE_TYPES.map(status => ({
                        ...status,
                        text: t(status.text, { ns: TRANSLATION_FILES.screens }),
                      }))}
                      placeholder={t('Type', { ns: TRANSLATION_FILES.screens })}
                      name="type"
                      search
                      selection
                      fluid
                      value={this.state.referenceType || PICTURE_TYPES[0].value}
                      onChange={this.handleTypeChange}
                    />
                  </div>
                </Grid.Column>
              </Grid>
            </Modal.Content>
            <Modal.Actions>
              <Button basic negative onClick={this.handleCancelAdd} icon="cancel" content={t('cancel', { ns: TRANSLATION_FILES.screens })} inverted />
              <Button basic positive onClick={this.handleAddPicture} icon="add" content={t('add', { ns: TRANSLATION_FILES.screens })} inverted />
            </Modal.Actions>
          </Modal>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default withTranslation(namespaces, { withRef: true })(AddPicture);



// WEBPACK FOOTER //
// ./src/containers/modals/AddPicture.jsx